











































import Vue from 'vue';

export default Vue.extend({
  name: 'ShowCardItem',

  props: {
    id: {
      type: Number,
      required: true,
    },

    showId: {
      type: Number,
      required: true,
    },

    userId: {
      type: Number,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      required: true,
    },

    rating: {
      type: Number,
      required: true,
    },

    username: {
      type: String,
      required: true,
    },

    userImage: {
      type: String,
      required: true,
    },

    created: {
      type: Number,
      default: 0,
    },

    padding: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    goToUser() {
      this.$router.push(`/profile/${this.userId}`);
    },
    goToReview() {
      this.$router.push(`/review/${this.showId}/${this.id}`);
    },
  },
});
